import styled from 'styled-components'

const FormContainer = styled.div`${props => `
  border-left: ${props.theme.border()};
  padding: ${props.theme.rem()};
  flex: 1;
`}`

export { FormContainer }